import { Box, Stack } from 'braid-design-system';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  EVENT_NAME_WRITE_PAYWALL_UPSELL_DISPLAYED,
  PAGE_WRITE,
} from 'src/app/shared/dataAnalytics/schema/constants';
import trackingAdapter from 'src/app/v1/dataAnalytics';
import { actionUpdateIsGreyedOut } from 'src/app/v1/state/modules/tealium/isGreyedOut';
import { AdSelectionWrapper } from 'src/app/v1/views/components/AdSelectionWrapper';
import { usePaywall } from 'src/app/v1/views/hooks/usePaywall';
import type { PurchaseContextUseCase } from 'src/graphql/generated';

import { PaywallBranding } from './components/PaywallBranding';
import { PaywallKeySellingPoint } from './components/PaywallKeySellingPoint';

import * as styles from './index.css';

const BULLET_POINTS_FEATURE = 'BulletPointsFeature';
const BRANDING_FEATURE = 'BrandingFeature';

export const PaywallSection = () => {
  const { isPaywallVisible, greyedOutFeatures } = usePaywall();
  const dispatch = useDispatch();

  const onProductSelect = useCallback(() => {
    dispatch(actionUpdateIsGreyedOut(true));
  }, [dispatch]);

  const features = greyedOutFeatures.map((feature) => feature?.__typename);
  const shouldPaywallKeySellingPointBeShown = features.includes(
    BULLET_POINTS_FEATURE,
  );
  const shouldPaywallBrandingBeShown = features.includes(BRANDING_FEATURE);

  useEffect(() => {
    if (isPaywallVisible) {
      trackingAdapter.sendLinkEvent({
        eventName: EVENT_NAME_WRITE_PAYWALL_UPSELL_DISPLAYED,
        currentPage: PAGE_WRITE,
      });
    }
  }, [isPaywallVisible]);

  if (!isPaywallVisible) {
    return null;
  }

  return (
    <Box className={styles.main}>
      <Box className={styles.upgradeWidgetWrap}>
        <Box padding={{ mobile: 'none', tablet: 'none', desktop: 'medium' }}>
          <AdSelectionWrapper
            purchaseContextUseCase={
              'BrandingAddonsOnly' as PurchaseContextUseCase
            }
            hideDisclaimer
            onProductSelect={onProductSelect}
          />
        </Box>
      </Box>

      <Box className={styles.paywallWrap}>
        <Box className={styles.paywall} />
        <Stack space="xlarge">
          <Box
            paddingY={
              !shouldPaywallBrandingBeShown
                ? { mobile: 'none', tablet: 'xxlarge', desktop: 'xxlarge' }
                : 'none'
            }
          >
            <PaywallKeySellingPoint
              shouldPaywallKeySellingPointBeShown={
                shouldPaywallKeySellingPointBeShown
              }
            />
          </Box>
          <PaywallBranding
            shouldPaywallBrandingBeShown={shouldPaywallBrandingBeShown}
          />
        </Stack>
      </Box>
    </Box>
  );
};
